module.exports = __webpack_public_path__ + "img/common-gif.1924740e.png";